var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndoEnabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1299 19.0605H7.12988C6.71988 19.0605 6.37988 18.7205 6.37988 18.3105C6.37988 17.9005 6.71988 17.5605 7.12988 17.5605H15.1299C17.4699 17.5605 19.3799 15.6505 19.3799 13.3105C19.3799 10.9705 17.4699 9.06055 15.1299 9.06055H4.12988C3.71988 9.06055 3.37988 8.72055 3.37988 8.31055C3.37988 7.90055 3.71988 7.56055 4.12988 7.56055H15.1299C18.2999 7.56055 20.8799 10.1405 20.8799 13.3105C20.8799 16.4805 18.2999 19.0605 15.1299 19.0605Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42957 11.5609C6.23957 11.5609 6.04957 11.4909 5.89957 11.3409L3.33957 8.78086C3.04957 8.49086 3.04957 8.01086 3.33957 7.72086L5.89957 5.16086C6.18957 4.87086 6.66957 4.87086 6.95957 5.16086C7.24957 5.45086 7.24957 5.93086 6.95957 6.22086L4.92957 8.25086L6.95957 10.2809C7.24957 10.5709 7.24957 11.0509 6.95957 11.3409C6.81957 11.4909 6.61957 11.5609 6.42957 11.5609Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoEnabled);
export default __webpack_public_path__ + "static/media/undoEnabled.63982204c094d135829cdfeb61e49546.svg";
export { ForwardRef as ReactComponent };